import Vue from 'vue';
import Vuex from 'vuex';

import mutations from '@/store/mutations';
import getters from '@/store/getters';
import actions from '@/store/actions';
import moduleA from '@/store/modules/moduleA';
import cart from '@/store/modules/cart';

Vue.use(Vuex);

const state = {
  count: 10,
  isLogin: false,
  userInfo: null,
  users: null,
  goodsList: null,
};

const modules = {
  a: moduleA,
  cart: cart,
};

const store = new Vuex.Store({
  state,
  mutations,
  getters,
  actions,
  modules,
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js